import * as AmplifyModules from 'aws-amplify';
import {ActionContext, ActionTree} from "vuex";
import {RootState} from "@/store/index";
import {CognitoUser} from "amazon-cognito-identity-js";

import {
    CLEAR_STACK_MUTATION, POP_NODE_MUTATION,
    PUSH_NODE_MUTATION,
    SET_CREDENTIALS_MUTATION,
    SET_LOGGED_MUTATION,
    SET_USER_MUTATION
} from "@/store/mutations";
import {BucketDir, BucketFile} from "@/store/types";

export const LOGIN_ACTION = 'LOGIN_ACTION';
export const CHECK_LOGIN_ACTION = 'CHECK_LOGIN_ACTION';
export const CONTINUE_LOGIN_ACTION = 'CONTINUE_LOGIN_ACTION';
export const LIST_BUCKET_ACTION = 'LIST_BUCKET_ACTION';
export const LOAD_FILE_ACTION = 'LOAD_FILE_ACTION';
export const OPEN_FOLDER_ACTION = 'OPEN_FOLDER_ACTION';
export const MOVE_TO_ACTION = 'MOVE_TO_ACTION';

interface HubEvent {
    channel: string;
    payload: {
        data: CognitoUser;
        event: string
    }
}

const actions: ActionTree<RootState, RootState> = {
    [LOGIN_ACTION]: ({state}: ActionContext<RootState, RootState>) => {
        const {loginUrl} = state;
        location.assign(loginUrl);
    },
    [MOVE_TO_ACTION]: ({state, commit}: ActionContext<RootState, RootState>, index: number) => {
        if (state.nodesStack.length - 1 === index) return;
        let count = state.nodesStack.length - 1 - index;
        while (count) {
            commit(POP_NODE_MUTATION);
            count--;
        }
    },
    [OPEN_FOLDER_ACTION]: ({commit}: ActionContext<RootState, RootState>, dir: BucketDir) => {
        commit(PUSH_NODE_MUTATION, dir);
    },
    [LOAD_FILE_ACTION]: async ({ state }: ActionContext<RootState, RootState>, file: BucketFile) => {
        const obj = await AmplifyModules.Storage.get(file.key);
        if (typeof obj === 'string') {
            window.open(obj);
        }
    },
    [LIST_BUCKET_ACTION]: async ({commit}: ActionContext<RootState, RootState>) => {
        const list = await AmplifyModules.Storage.list('');

        const root: BucketDir = {
            name: " . ",
            file: [],
            subdirs: [],
        };

        list.forEach((fileEntity: BucketFile) => {
            if(!fileEntity.key) return;

            const splits: string[] = fileEntity.key.split('/');

            if (!splits) return;

            let node = root;

            while (splits.length > 1) {
                const part: string | undefined = splits.shift();

                if (node && node.subdirs) {
                    let dir: BucketDir | undefined = node.subdirs.find((dir: BucketDir) => dir.name === part);

                    if (!dir) {
                       dir = {
                           name: part,
                           subdirs: [],
                           file: []
                       } as BucketDir;

                       node.subdirs.push(dir);
                    }

                    node = dir;
                }
            }

            fileEntity.shortkey = splits[0];

            if (node.file) {
                node.file.push(fileEntity);
            }
        });

        commit(CLEAR_STACK_MUTATION);
        commit(PUSH_NODE_MUTATION, root);
        // commit(SET_FILES_MUTATION, list);
    },
    [CONTINUE_LOGIN_ACTION]: async ({ commit }: ActionContext<RootState, RootState>) => {
        const creds = await AmplifyModules.Auth.currentCredentials();
        commit(SET_CREDENTIALS_MUTATION, creds);
        commit(SET_LOGGED_MUTATION, true);
    },
    [CHECK_LOGIN_ACTION]: async ({ commit, dispatch }: ActionContext<RootState, RootState>) => {
        let user: CognitoUser;

        try {
            user = await AmplifyModules.Auth.currentAuthenticatedUser();

            commit(SET_USER_MUTATION, user);
            await dispatch(CONTINUE_LOGIN_ACTION);
            await dispatch(LIST_BUCKET_ACTION);
        } finally {
            AmplifyModules.Hub.listen('auth', {
                async onHubCapsule(caps: HubEvent) {
                    if (caps.channel === 'auth' && caps.payload.event === 'signIn') {
                        user = await AmplifyModules.Auth.currentAuthenticatedUser();

                        commit(SET_USER_MUTATION, user);
                        await dispatch(CONTINUE_LOGIN_ACTION);
                        await dispatch(LIST_BUCKET_ACTION);
                    }
                }
            });
        }
    },
};

export default actions;
